/**
 * Copies the provided text to the clipboard and optionally calls a callback function.
 *
 * @param {string} text - The text to be copied to the clipboard.
 * @param {() => void} [callBackNotify] - An optional callback function to be called after the text is copied.
 *
 * @example
 * onClickCopy('Hello, World!', () => {
 *   console.log('Text copied to clipboard!');
 * });
 *
 * Dependencies:
 * - This function relies on the `navigator.clipboard.writeText` method, which is available in most modern browsers.
 */
export function onClickCopy(text: string, callBackNotify?: () => void) {
  navigator.clipboard.writeText(text);
  if (callBackNotify) {
    callBackNotify();
  }
}
